"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetPassword = exports.getCollectedData = exports.modifyUserData = exports.changePassword = exports.checkUserAccount = exports.login = exports.register = exports.getVerificationCode = void 0;
var request_1 = __importDefault(require("@/utils/request"));
function getVerificationCode() {
    return (0, request_1.default)({
        url: "/users/code",
        method: "get",
    });
}
exports.getVerificationCode = getVerificationCode;
function register(data) {
    if (data === void 0) { data = {}; }
    return (0, request_1.default)({
        url: "/users/create",
        method: 'post',
        data: data
    });
}
exports.register = register;
function login(data) {
    if (data === void 0) { data = {}; }
    return (0, request_1.default)({
        url: "/users/login",
        method: 'post',
        data: data
    });
}
exports.login = login;
function checkUserAccount(data) {
    if (data === void 0) { data = {}; }
    return (0, request_1.default)({
        url: "/users/check",
        method: 'get',
        params: data
    });
}
exports.checkUserAccount = checkUserAccount;
function changePassword(data) {
    if (data === void 0) { data = {}; }
    return (0, request_1.default)({
        url: "/users/change-password",
        method: 'post',
        data: data
    });
}
exports.changePassword = changePassword;
function modifyUserData(data) {
    if (data === void 0) { data = {}; }
    return (0, request_1.default)({
        url: "/users/modify",
        method: 'post',
        data: data
    });
}
exports.modifyUserData = modifyUserData;
function getCollectedData(params) {
    return (0, request_1.default)({
        url: "/users/collected-info",
        method: "get",
        params: params
    });
}
exports.getCollectedData = getCollectedData;
function resetPassword(params) {
    return (0, request_1.default)({
        url: "/users/reset-password",
        method: "post",
        data: params
    });
}
exports.resetPassword = resetPassword;
